import axios from "axios";
import { setMOH } from "@/helpers/BatchService.js";

import {
  authDeviceHeader,
  authWithDomainHeader,
  authDeviceWithDomainHeader,
} from "../../authServices/auth.header";

const API_URL = process.env.VUE_APP_ROOT_API;
const KIOSK_URL = process.env.VUE_APP_KIOSK_PRODUCTION_ROOT_API;
class DomainService {
  // Domain list
  async getDomainList(filter = "") {
    return await axios
      .get(API_URL + `pbx-app/domain` + filter, {
        headers: authDeviceHeader(),
      })
      .then((response) => {
        if (filter == "") {
          sessionStorage.setItem(
            "domains",
            JSON.stringify(response.data.result)
          );
        }
        return response.data;
      });
  }
  // Domain details
  async getDomainDetails() {
    return await axios
      .get(API_URL + `pbx-app/domain/detail`, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        sessionStorage.setItem("domain", JSON.stringify(response.data.result));
        setMOH();
        return response.data.result;
      });
  }
  // Add domain details
  async addDomain(data) {
    return await axios
      .post(API_URL + `pbx-app/domain`, data, {
        headers: authDeviceHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Update domain details
  async updateDomainDetails(domain_id, data) {
    return await axios
      .put(API_URL + `pbx-app/domain/detail`, data, {
        headers: authWithDomainHeader(domain_id),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Update domain small details
  async updateDomain(domain_id, data) {
    return await axios
      .patch(API_URL + `pbx-app/domain/detail`, data, {
        headers: authWithDomainHeader(domain_id),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Update domain details
  async getDomainDetail(domain_id) {
    return await axios
      .get(API_URL + `pbx-app/domain/detail`, {
        headers: authWithDomainHeader(domain_id),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Get PBX server list
  async getPBXServerList(filter = "") {
    return await axios
      .get(API_URL + "pbx-app/pbx-server" + filter, {
        headers: authDeviceHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Filter company data
  async getDirectoryAddress(filter) {
    return await axios
      .get(KIOSK_URL + "crm/pbx/company-filter" + filter, {
        headers: authDeviceHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Filter company data
  async getCompanyDeails(code) {
    return await axios
      .get(`${KIOSK_URL}crm/pbx/installation/${code}`, {
        headers: authDeviceHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Get company data
  async getCompanyData(id) {
    return await axios
      .get(KIOSK_URL + "crm/pbx/company/" + id, { headers: authDeviceHeader() })
      .then((response) => {
        return response.data;
      });
  }
}

export default new DomainService();
